<div class="page-wrapper">

    <app-bees-header></app-bees-header>

    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div>



    <!-- PAGE HEADER -->

    <section class="page-header">

        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>

        <div class="container">

            <div class="page-header__inner">

                <div class="page-header__img-1">
                    <img src="assets/images/resources/page-header-img-1.png" alt="">
                </div>

                <div class="page-header__shape-1 float-bob-y">
                    <img src="assets/images/shapes/page-header-shape-1.png" alt="">
                </div>

                <h3>Forest Products

                </h3>

                <div class="thm-breadcrumb__inner">

                    <ul class="thm-breadcrumb list-unstyled">

                        <li>
                            <a href="index.html">Home</a>
                        </li>

                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>

                        <li>
                            <a href="services.html">Products</a>
                        </li>

                        <li>
                            <span class="fas fa-angle-right"></span>
                        </li>

                        <li>Forest Products</li>

                    </ul>

                </div>

            </div>

        </div>

    </section>



    <!-- SERVICE DETAILS -->

    <section class="service-details">
        <div class="container">
            <div class="row"> <!-- LEFT SIDEBAR -->
                <div class="col-xl-4 col-lg-5">
                    <div class="service-details__sidebar">
                        <div class="service-details__services-box">
                            <h3 class="service-details__services-title">Forest Products
                            </h3>
                            <ul class="service-details__services-list list-unstyled">
                                <li [class.active]="activeSection === 'honey'"> <a (click)="goToSection('honey')">
                                        Forest Honey
                                        <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cardamom'"> <a (click)="goToSection('cardamom')">
                                        Bamboo Products
                                        <span class="icon-next"></span> </a> </li>

                            </ul>
                        </div>
                        <div class="service-details__sidebar-contact">
                            <div class="service-details__sidebar-contact-img">
                                <div class="inner"> <img src="assets/images/services/service-details-sidebar-img.png"
                                        alt=""> </div>
                            </div>
                            <div class="service-details__sidebar-contact-content">
                                <div class="icon"> <span class="icon-phone-call"></span> </div>
                                <h2> <a href="tel:9447117399">+91 944 7117 399 </a> </h2>
                                <h2 style="color:#fd5523;"> If You Need Any Help <br> Contact With Us </h2>
                            </div>
                        </div>
                    </div>
                </div> <!-- RIGHT CONTENT -->
                <div class="col-xl-8 col-lg-7">
                    <div class="service-details__left"> <!-- PEPPER -->
                        <div *ngIf="activeSection === 'honey'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-10.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Forest Honey
                            </h3>
                            <p class="service-details__text-1">Forest honey is collected from dense forests by tribals.
                                Forest honey is highly valuable as medicine. It is available in sealed packets of 250,
                                500 and 1000 milli litres </p>
                        </div> <!-- CARDAMOM -->
                        <div *ngIf="activeSection === 'cardamom'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-11.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Bamboo Products
                            </h3>
                            <p class="service-details__text-1">Forest honey is collected from dense forests by tribals.
                                Forest honey is highly valuable as medicine. It is available in sealed packets of 250,
                                500 and 1000 milli litres </p>
                        </div> <!-- CINNAMON -->

                    </div>
                </div>
            </div>
        </div>
    </section>


    <app-bees-footer></app-bees-footer>

</div>



<div class="lock-popup"
     *ngIf="showPopup">

    <div class="popup-box">

        <h3>

            Enter Access Code

        </h3>

        <div class="pin-box">

            <input #p1
                   maxlength="1"
                   [(ngModel)]="pin1"
                   (input)="moveNext($event,p2)">

            <input #p2
                   maxlength="1"
                   [(ngModel)]="pin2"
                   (input)="moveNext($event,p3)">

            <input #p3
                   maxlength="1"
                   [(ngModel)]="pin3"
                   (input)="moveNext($event,p4)">

            <input #p4
                   maxlength="1"
                   [(ngModel)]="pin4"
                   (input)="moveNext($event)">

        </div>

        <p class="error"
           *ngIf="errorMsg">

            {{errorMsg}}

        </p>

    </div>

</div>

<div *ngIf="!showPopup">

    <!-- EXISTING PAGE -->

</div>